<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white"
  >
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center justify-between">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Overview
          </h6>
          <h2 class="text-blueGray-700 text-xl font-semibold">
            创建入口访问次数
          </h2>
        </div>
        <div class="flex items-center gap-2">
          <el-select v-model="compareDays" @change="handleCompareChange" size="small" style="width: 140px;">
            <el-option label="近7天" :value="7" />
            <el-option label="近14天" :value="14" />
            <el-option label="近30天" :value="30" />
          </el-select>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto">
      <div class="relative h-350-px">
        <canvas id="scene-entry-chart"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart, registerables } from "chart.js";
import { getAdminApiUrl } from "@/api/luckdraw.js";
import { getUserToken } from "@/utils/auth.js";

// 注册所有Chart.js组件
Chart.register(...registerables);

const COLORS = [
  { bg: '#3b82f6', border: '#3b82f6' },
  { bg: '#10b981', border: '#10b981' },
  { bg: '#f59e0b', border: '#f59e0b' },
  { bg: '#8b5cf6', border: '#8b5cf6' },
  { bg: '#ef4444', border: '#ef4444' },
  { bg: '#ec4899', border: '#ec4899' },
  { bg: '#06b6d4', border: '#06b6d4' }
];

function getDateLabel(daysAgo) {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return `${date.getMonth() + 1}月${date.getDate()}日`;
}

// 生成模拟数据
function generateSceneData() {
  return [
    Math.floor(800 + Math.random() * 400),
    Math.floor(500 + Math.random() * 300),
    Math.floor(300 + Math.random() * 200),
    Math.floor(200 + Math.random() * 150),
    Math.floor(100 + Math.random() * 100)
  ];
}

// 从API获取数据
async function fetchSceneEntryStats(days) {
  const token = getUserToken();
  const response = await fetch(getAdminApiUrl('/stat/daily/create/scene'), {
    method: 'POST',
    headers: {
      'Token': `${token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ days: days })
  });
  const result = await response.json();
  if (result.sta === 0 && result.data) {
    return result.data;
  }
  return null;
}

export default {
  data() {
    return {
      compareDays: 7,
      chart: null,
    };
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    async loadData() {
      await this.$nextTick();
      const apiData = await fetchSceneEntryStats(this.compareDays);

      let datasets;

      if (apiData && apiData.datasets && apiData.datasets.length > 0) {
        datasets = apiData.datasets.map((ds, idx) => ({
          label: ds.label,
          backgroundColor: ds.color || COLORS[idx % COLORS.length].bg,
          borderColor: ds.color || COLORS[idx % COLORS.length].border,
          data: ds.data,
          borderWidth: 2,
          barPercentage: 0.8,
        }));
      } else {
        // 使用 Demo 数据展示效果
        datasets = [];
        for (let i = 0; i < Math.min(this.compareDays, 7); i++) {
          datasets.push({
            label: getDateLabel(i),
            backgroundColor: COLORS[i % COLORS.length].bg,
            borderColor: COLORS[i % COLORS.length].border,
            data: generateSceneData(),
            borderWidth: 2,
            barPercentage: 0.8,
          });
        }
      }

      const config = {
        type: "bar",
        data: {
          labels: apiData?.labels || ['场景A', '场景B', '场景C', '场景D', '场景E'],
          datasets: datasets,
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              labels: {
                color: "rgba(0,0,0,.6)",
                usePointStyle: true,
              },
              position: 'bottom',
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.raw;
                  const dataset = context.dataset;
                  const firstValue = dataset.data[0];
                  const percent = ((value / firstValue) * 100).toFixed(1);
                  return `${dataset.label}: ${value} (${percent}%)`;
                }
              }
            },
          },
          scales: {
            x: {
              display: true,
              title: { display: true, text: "场景" },
              grid: {
                display: false,
              },
            },
            y: {
              display: true,
              title: { display: true, text: "点击次数" },
              grid: {
                color: "rgba(33, 37, 41, 0.1)",
              },
              ticks: {
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            },
          },
        },
      };

      // 销毁旧图表
      if (window.mySceneEntryChart) {
        window.mySceneEntryChart.destroy();
      }

      const ctx = document.getElementById("scene-entry-chart").getContext("2d");
      window.mySceneEntryChart = new Chart(ctx, config);
    },
    handleCompareChange() {
      this.loadData();
    },
  },
};
</script>
